var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { t } from '../../services';
export var computeRecordTypeOptions = function (entityTypes, selected) {
    if (selected === void 0) { selected = ''; }
    var defaultPlaceholder = {
        label: t('create-list.choose-record-type'),
        selected: false,
        value: ''
    };
    var options = entityTypes
        .map(function (_a) {
        var id = _a.id, label = _a.label;
        return ({
            label: label,
            value: id,
            selected: id === selected
        });
    });
    // EntityTypeSelectOption has label as ReactNode, but we just created it above
    // where all these labels are string only, so we can safely coerce to string
    options.sort(function (a, b) { return a.label.localeCompare(b.label); });
    if (!selected) {
        options = __spreadArray([defaultPlaceholder], options, true);
    }
    return options;
};
